(function() {
  'use strict';

  const SELECTOR = '.js-plp-split-hero-scroll';
  const HEADER_OFFSET = 100;

  function getHeaderOffset() {
    return HEADER_OFFSET;
  }

  function findTarget(anchor) {
    if (!anchor) {
      return null;
    }

    const byId = document.getElementById(anchor);

    if (byId) {
      return byId;
    }

    return document.querySelector(`[data-section-id="${anchor}"]`);
  }

  function handleAnchorClick(event) {
    const link = event.currentTarget;
    const anchor = link.getAttribute('data-anchor');
    const target = findTarget(anchor);

    if (!anchor || !target) {
      return;
    }

    event.preventDefault();

    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }

  function init() {
    const links = document.querySelectorAll(SELECTOR);

    links.forEach((link) => {
      link.removeEventListener('click', handleAnchorClick);
      link.addEventListener('click', handleAnchorClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
